@if (loading) {
  <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading version history...</p>
  </div>
} @else if (versions.length === 0) {
  <mat-card class="empty-state">
    <mat-card-content>
      <mat-icon>history</mat-icon>
      <p>No previous versions</p>
    </mat-card-content>
  </mat-card>
} @else {
  <table mat-table [dataSource]="versions" class="versions-table">

    <!-- Version Number -->
    <ng-container matColumnDef="versionNumber">
      <th mat-header-cell *matHeaderCellDef>Version</th>
      <td mat-cell *matCellDef="let row">v{{ row.versionNumber }}</td>
    </ng-container>

    <!-- Name -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <!-- Status -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let row">
        <mat-chip-set>
          <mat-chip [class.status-superseded]="row.status === 'Superseded'"
                    [class.status-active]="row.status === 'Active'">
            {{ row.status }}
          </mat-chip>
        </mat-chip-set>
      </td>
    </ng-container>

    <!-- Superseded Date -->
    <ng-container matColumnDef="supersededDate">
      <th mat-header-cell *matHeaderCellDef>Superseded Date</th>
      <td mat-cell *matCellDef="let row">
        @if (row.supersededDate) {
          {{ row.supersededDate | date:'MM/dd/yyyy' }}
        } @else {
          —
        }
      </td>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button (click)="openVersion(row)" title="Open in new tab">
          <mat-icon>open_in_new</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        class="version-row"
        (click)="openVersion(row)"></tr>
  </table>
}
